import React from 'react';
import { ConversationListType } from '../../Enums/ConversationListType.enum';
import { useLazyMessagesByConversationQuery } from '../../../../graphql/graphql';
import useConversations, {
	DefaultConversationFilter,
} from '../../Hooks/useConversations';
import useFlatData from '../../../Base/Hooks/useFlatData';
import FlatList from '../../../Base/Components/FlatList';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import ActionCenterConversationListItem from './ActionCenterConversationListItem';

interface Props {
	type: ConversationListType;
	defaultFilter?: DefaultConversationFilter;
}

const WRAPPER_ID = 'actionCenterConversationListWrapper';

const ActionCenterConversationList: React.FC<Props> = ({
	type,
	defaultFilter,
}) => {
	const [getConversationsQuery, { data, isLoading }] =
		useLazyMessagesByConversationQuery();

	const { getConversations, getNextPage, page, setPage } = useConversations({
		getConversationsQuery,
		defaultFilter,
	});

	const { flatData, hasMoreData, loadData } = useFlatData(
		getConversations,
		{
			data: data?.messagesByConversation?.data,
			totalPages: data?.messagesByConversation?.meta?.totalPages,
			page: data?.messagesByConversation?.meta?.page,
		},
		page,
		setPage,
		{
			folder: type,
			conversationType: 'NORMAL',
			pagination: {
				take: 20,
				order: {
					key: 'lastMessage.createdAt',
					how: 'DESC',
				},
			},
		},
	);

	return (
		<ScrollContainer wrapperId={WRAPPER_ID}>
			<FlatList
				onRefresh={loadData}
				onLoadMore={getNextPage}
				data={flatData}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				scrollableTargetId={WRAPPER_ID}
				itemKey={'id'}
				renderItem={item => (
					<ActionCenterConversationListItem
						item={item}
						onSeen={loadData}
						showSender={type === ConversationListType.INBOX}
						type={type}
					/>
				)}
			/>
		</ScrollContainer>
	);
};

export default ActionCenterConversationList;
